"use strict";
/**
 * Shared TypeScript types for the curriculum coverage API response.
 * Used by both the sync-server (producer) and teacher-portal (consumer).
 */
Object.defineProperty(exports, "__esModule", { value: true });
